/* eslint-disable import/prefer-default-export */

import qs from 'qs'
import { push } from 'react-router-redux'

import {
  FETCH_POSITION_FAILURE,
  FETCH_POSITION_REQUEST,
  FETCH_POSITION_SUCCESS,
  FETCH_POSITIONS_FAILURE,
  FETCH_POSITIONS_REQUEST,
  FETCH_POSITIONS_SUCCESS,
  SELECT_POSITION,
} from '../constants/officeRunnerConstants'

// TODO This should be filtered in API instead of on frontend
const positionIdsBlacklist = process.env.REACT_APP_EXCLUDE_POSITION_IDS
  .split(',')
  .filter(id => id)
const positionIdsWhitelist = process.env.REACT_APP_INCLUDE_POSITION_IDS
  .split(',')
  .filter(id => id)

export const fetchPositionsAndRedirect = () => {
  return (dispatch, getState) => {
    return dispatch(fetchPositions())
      .then(() => dispatch(prefillSelectedPosition()))
      .then(() => {
        let destination = '/positions'
        const { positions } = getState()

        if (positions.length === 0) {
          const currentYear = (new Date()).getFullYear()
          destination = `/future_election/${currentYear}`
        }

        return dispatch(push(destination))
      })
  }
}

export const fetchPositionsFailure = error => (
  { type: FETCH_POSITIONS_FAILURE, error }
)

export const fetchPositionsRequest = () => (
  { type: FETCH_POSITIONS_REQUEST }
)

export const fetchPositionsSuccess = positions => (
  { type: FETCH_POSITIONS_SUCCESS, positions }
)

// Fetch multiple positions
export const fetchPositions = () => {
  let electionId
  if (
    process.env.REACT_APP_API_ELECTION_ID
    && process.env.REACT_APP_API_ELECTION_ID.length > 0
  ) {
    electionId = process.env.REACT_APP_API_ELECTION_ID
  }

  return (dispatch, getState) => {
    const { latLng, lead } = getState()
    const params = qs.stringify({
      ...latLng,
      combine_duplicates: 1,
      election_id: electionId,
      exclude_statewide: process.env.REACT_APP_API_EXCLUDE_STATEWIDE_POSITIONS,
      include_candidates: process.env.REACT_APP_API_INCLUDE_CANDIDATES,
      include_endorsements: process.env.REACT_APP_API_INCLUDE_ENDORSEMENTS,
      include_uncertified_candidates: process.env.REACT_APP_API_INCLUDE_UNCERTIFIED_CANDIDATES,
      tenant: process.env.REACT_APP_TENANT_ID,
      year: lead.year || process.env.REACT_APP_ACTIVE_ELECTION_YEARS.split(',')[0],
    })

    dispatch(fetchPositionsRequest())
    return fetch(`${process.env.REACT_APP_CE_API_ROOT}/positions?${params}`, {
      method: 'get',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-api-key': process.env.REACT_APP_API_KEY,
      }
    })
    .then(response => {
      if (!response.ok) {
        return Promise.reject(response.statusText)
      }
      return response.json()
    })
    .then(json => {
      const positions = json.positions.filter((p) => {
        if (p && p.normalized_position && p.normalized_position.id === 10) {
          return false
        } else if (positionIdsWhitelist.length > 0) { // Prefer whitelisting over blacklisting
          return positionIdsWhitelist.indexOf(p.position_id.toString()) !== -1
        } else if (positionIdsBlacklist.length > 0) {
          return positionIdsBlacklist.indexOf(p.position_id.toString()) === -1
        } else {
          return true // No filter? Include all positions
        }
      })

      return dispatch(fetchPositionsSuccess(positions))
    })
    .catch(error => dispatch(fetchPositionsFailure(error)))
  }
}

export const fetchPositionFailure = error => (
  { type: FETCH_POSITION_FAILURE, error }
)

export const fetchPositionRequest = () => (
  { type: FETCH_POSITION_REQUEST }
)

export const fetchPositionSuccess = position => (
  { type: FETCH_POSITION_SUCCESS, position }
)

// Fetch a single position
export const fetchPosition = (positionId, secretToken) => {
  return (dispatch, getState) => {
    const params = qs.stringify({
      position_id: positionId,
      secret_token: secretToken,
    })

    dispatch(fetchPositionRequest())
    return fetch(`${process.env.REACT_APP_CE_API_ROOT}/leads/verify?${params}`, {
      method: 'get',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-api-key': process.env.REACT_APP_API_KEY,
      }
    })
    .then(response => {
      if (!response.ok) {
        return Promise.reject(response.statusText)
      }
      return response.json()
    })
    .then(json => dispatch(fetchPositionSuccess(json)))
    .catch(error => dispatch(fetchPositionFailure(error)))
  }
}

// Select position
//
// Checks screen size to determine whether to select position or not. If we're
// on a small device we want to see the position list first, and select a
// position ourselves. On bigger screens we automatically select a position so
// that the master/detail view doesn't look empty.
export const prefillSelectedPosition = () => {
  return (dispatch, getState) => {
    let state = getState()
    const position = state.positions[0]

    return dispatch(
      selectPosition(state.browser.greaterThan.medium ? position : null)
    )
  }
}

export const selectPosition = (position) => (
  { type: SELECT_POSITION, position }
)



// WEBPACK FOOTER //
// ./src/actions/positionActionCreators.js